module.exports = __webpack_public_path__ + "static/media/profile.06123047.png";